(() => {
    let dropdowns = document.querySelectorAll('.registration__form .dropdown');

    const initStateReady = () => {
        if (dropdowns) {
            dropdowns.forEach((dropdown) => {
                sortSelect(dropdown, '');
            });
        }
    };

    const sortSelect = (dropdown, sortVal) => {
        // Checks for an object or string. Uses string as ID.
        let selElem = dropdown;
        let tmpAry = [];
        let firstOption = [];

        // Builds the options list.
        for (let i = 0; i < selElem.options.length; i++) {
            if (i === 0) {
                // in most cases this is the placeholder. We dont want to sort for it
                firstOption[i] = [];
                firstOption[i]['text'] = selElem.options[i].text;
                firstOption[i]['value'] = selElem.options[i].value;
            } else {
                tmpAry[i] = [];
                tmpAry[i]['text'] = selElem.options[i].text;
                tmpAry[i]['value'] = selElem.options[i].value;
            }
        }

        // allows sortVal to be optional, defaults to text.
        switch (sortVal) {
            case 'value': // sort by value
                sortVal = 'value';
                break;
            default:
                // sort by text
                sortVal = 'text';
        }
        tmpAry.sort(function (a, b) {
            return a[sortVal] === b[sortVal] ? 0 : a[sortVal] < b[sortVal] ? -1 : 1;
        });

        // removes all options from the select.
        while (selElem.options.length > 0) {
            selElem.options[0] = null;
        }

        // add placeholder
        if (firstOption[0]) {
            selElem.options[0] = new Option(firstOption[0]['text'], firstOption[0]['value']);
        }

        // recreates all options with the new order.
        for (let i = 0; i < tmpAry.length; i++) {
            if (tmpAry[i]) {
                selElem.options[i + 1] = new Option(tmpAry[i]['text'], tmpAry[i]['value']);
            }
        }

        return true;
    };

    document.addEventListener('readystatechange', () => {
        if (document.readyState !== 'complete') return;

        initStateReady();
    });
})();
